import * as React from 'react';

export interface ISearchResultsContext {
  isMobile: boolean;
}

export const SearchResultsContext = React.createContext<ISearchResultsContext>({
  isMobile: false,
});
